import * as React from 'react'
import CircularProgress from 'material-ui/CircularProgress'
import AlertError from 'material-ui/svg-icons/alert/error'
import FileAttachment from 'material-ui/svg-icons/file/attachment'
import {Downloadable} from '../Data/Downloadable'

export function downloadIcon(download: Downloadable) {
    switch (download.type) {
        case 'Default':
            return <FileAttachment/>
        case 'Loading':
            return <CircularProgress size={24}/>
        case 'Failure':
            return <AlertError/>
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/DownloadIcon.tsx